/**
 * FlahaSOIL motion foundation.
 *
 * These tokens keep interface motion short, purposeful, and independent of
 * application state. Scientific values and route outcomes must never depend
 * on an animation completing.
 */
export const reducedMotionMediaQuery =
	"@media (prefers-reduced-motion: reduce)" as const;

export const motionTokens = {
	duration: {
		instant: 0,
		focus: 100,
		quick: 140,
		standard: 220,
		deliberate: 340,
		entry: 420,
	},
	easing: {
		standard: "cubic-bezier(0.2, 0, 0, 1)",
		enter: "cubic-bezier(0.16, 1, 0.3, 1)",
		exit: "cubic-bezier(0.4, 0, 1, 1)",
		emphasis: "cubic-bezier(0.2, 0.8, 0.2, 1)",
	},
	entry: {
		opacityFrom: 0,
		transformFrom: "translate3d(0, 10px, 0) scale(0.99)",
		transformTo: "translate3d(0, 0, 0) scale(1)",
	},
	exit: {
		opacityTo: 0,
		transformTo: "translate3d(0, -6px, 0) scale(0.995)",
	},
	transition: {
		surface:
			"background-color 220ms cubic-bezier(0.2, 0, 0, 1), border-color 220ms cubic-bezier(0.2, 0, 0, 1), box-shadow 220ms cubic-bezier(0.2, 0, 0, 1), transform 220ms cubic-bezier(0.2, 0, 0, 1)",
		focus:
			"outline-color 100ms cubic-bezier(0.2, 0, 0, 1), box-shadow 100ms cubic-bezier(0.2, 0, 0, 1)",
		entry:
			"opacity 420ms cubic-bezier(0.16, 1, 0.3, 1), transform 420ms cubic-bezier(0.16, 1, 0.3, 1)",
		exit:
			"opacity 140ms cubic-bezier(0.4, 0, 1, 1), transform 140ms cubic-bezier(0.4, 0, 1, 1)",
	},
	reducedMotion: {
		mediaQuery: reducedMotionMediaQuery,
		duration: 0,
		transition: "none",
		animation: "none",
		transform: "none",
	},
} as const;

export type FlahaMotionTokens = typeof motionTokens;
